/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

enum Paths {
  home = "/",
  exams = "/exams",
  booking = "/schedule",
  heartReport = "/heart-report",
  liveExam = "/live-exam",
  liveExamApp = "/live-exam-app",
  liveExamCompatibilityTest = "/live-exam-compatibility-test",
  selfExam = "/self-exam",
  newSelfExam = "/new-self-exam",
  signUp = "/sign-up",
  forgotPassword = "/forgot-password",
  updateProfile = "/update-profile",
  authCallback = "/auth-callback",
  postAuthPipeline = "/post-auth-pipeline",
  profile_stethoscope = "/profile/stethoscope",
  hipaa = "/hipaa",
  support = "/support",
  contact = "/contact",
  terms = "/terms",
  privacy = "/privacy",
  loggedOut = "/signed-out",
  logOut = "/sign-out",
}

const footerNavigation = [
  { name: "About Medaica", href: "https://www.medaica.com", newWindow: true },
  { name: "Contact", href: "https://medaica.com/pages/contact", newWindow: true },
  { name: "Terms", href: "https://medaica.com/pages/terms-of-service", newWindow: true },
  { name: "Privacy", href: "https://medaica.com/pages/medaica-privacy-policy", newWindow: true },
  { name: "HIPAA", href: Paths.hipaa, newWindow: true },
]

// The Medaica Patient app: its store pages, for the landing page badges and the live-exam phone page, and its
// Android package, which the phone page's "Open the Medaica app" link names. The iOS app id is also in
// public/index.html, for the Smart App Banner.
const appStoreUrl = "https://apps.apple.com/us/app/medaica-patient/id6466788535"
const googlePlayUrl = "https://play.google.com/store/apps/details?id=com.medaica.patient&pcampaignid=web_share"
const androidAppPackage = "com.medaica.patient"

export { Paths, footerNavigation, appStoreUrl, googlePlayUrl, androidAppPackage }
